import { AuthService } from './../auth/auth.service';
import { Component, DoCheck, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-elements',
  templateUrl: './nav-elements.component.html',
  styleUrls: ['./nav-elements.component.scss'],
})
export class NavElementsComponent implements OnInit, DoCheck {
  public userIsAuthenticated = false;
  public userRole = 'basic';
  public userID = '';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  ngDoCheck(): void {
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.userRole = this.authService.getUserRole();
    this.userID = this.authService.getUserID();
  }

  onLogout(): void {
    this.authService.logout('');
  }
}
